import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { usePageTitle } from "../../hooks/usePageTitle";
import { forwardNext } from "../../utils/authRedirect";
import PhoneAuth from "./PhoneAuth";
import EmailAuth from "./EmailAuth";

export default function Signup() {
  usePageTitle("Create Account — Lets Go Sauna");
  const location = useLocation();
  const [method, setMethod] = useState<"email" | "phone">("phone");

  const tabStyle: React.CSSProperties = {
    padding: "8px 16px",
    border: "1px solid #d1d5db",
    background: "transparent",
    cursor: "pointer",
    fontSize: 14,
    flex: 1,
    textAlign: "center",
  };

  const activeTabStyle: React.CSSProperties = {
    ...tabStyle,
    background: "#2563EB",
    color: "#fff",
    borderColor: "#2563EB",
  };

  return (
    <div style={{ maxWidth: 400, margin: "100px auto", padding: 20 }}>
      <h2>Create Account</h2>
      <div style={{ display: "flex", gap: 0, marginBottom: 20, borderRadius: 6, overflow: "hidden" }}>
        <button
          type="button"
          onClick={() => setMethod("email")}
          style={method === "email" ? activeTabStyle : tabStyle}
        >
          Email
        </button>
        <button
          type="button"
          onClick={() => setMethod("phone")}
          style={method === "phone" ? activeTabStyle : tabStyle}
        >
          Phone
        </button>
      </div>
      {method === "email" ? (
        <EmailAuth mode="signup" redirectTo="/" />
      ) : (
        <>
          <PhoneAuth mode="signup" redirectTo="/" />
          <p style={{ marginTop: 12, fontSize: 12, color: "#6b7280", textAlign: "center", lineHeight: 1.5 }}>
            Lets Go Sauna will send a one-time SMS code to verify your phone number. Message and data rates may apply. Reply STOP to opt out, HELP for help.
          </p>
        </>
      )}
      <p style={{ marginTop: 16, textAlign: "center", fontSize: 14 }}>
        Already have an account?{" "}
        <Link to={`/login${forwardNext(location.search)}`} style={{ color: "#2563EB", textDecoration: "none" }}>
          Sign in
        </Link>
      </p>
    </div>
  );
}
